export interface BrandRef {
  id: number;
  name: string;
}

export interface MarketRef {
  id: number;
  name: string;
}

export interface FilterRef {
  type: string;
  filterId: number;
  filterOptions?: number[];
}

export interface PeriodRef {
  type: string;
  startDate?: string;
  endDate?: string;
}

export interface CurrentScreenContext {
  brands: BrandRef[];
  markets: MarketRef[];
  module: string;
  metricKeys: string[];
  segments: number[];
  filters: FilterRef[];
  audienceBase: string;
  viewMode: string;
  visualizationType: string;
  groupedBy: string;
  statTest: string;
  intervalType: string;
  period: PeriodRef;
}

export const DEFAULT_SCREEN_CONTEXT: CurrentScreenContext = {
  brands: [],
  markets: [],
  module: "",
  metricKeys: [],
  segments: [],
  filters: [],
  audienceBase: "GENPOP",
  viewMode: "POINT_IN_TIME",
  visualizationType: "BAR",
  groupedBy: "BRAND",
  statTest: "NONE",
  intervalType: "",
  period: { type: "" },
};
